import { useAuth } from 'lib/auth';
import React, { useState } from 'react';
import { initialPayment } from '../api/initialPayment';
import { verifyPayment } from '../api/verifyPayment';

export const InitialDepositRequired = () => {
  const { refreshUser, user, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [transactionRef, setTransactionRef] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');

  const handleInitiatePayment = async () => {
    setLoading(true);
    setStatusMessage('');
    try {
      const response = await initialPayment();
      console.log(response);
      const ref = response.data.transactionReference;
      setTransactionRef(ref);
      setStatusMessage(
        'Payment initiated. Please complete the payment on your mobile device and then click "Verify Payment" below.'
      );
    } catch (error) {
      setStatusMessage('Failed to initiate payment. Please try again or contact support.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyPayment = async () => {
    if (!transactionRef) {
      setStatusMessage('Please initiate a payment first.');
      return;
    }

    setVerifying(true);
    setStatusMessage('');
    try {
      const response = await verifyPayment({ externalReference: transactionRef });
      console.log(response);
      await refreshUser();

      if (user?.status === 'ACTIVE') {
        window.location.reload(); // Or navigate to dashboard
      } else {
        setStatusMessage(
          'Payment verified but your account is not yet active. Please contact support for assistance.'
        );
      }
    } catch (error) {
      setStatusMessage(
        'Payment verification failed. Please ensure payment is complete or try again later.'
      );
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="">
      <div className="">
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">
          Welcome to With Love Uganda 🎉
        </h1>
        <p className="text-gray-600 mb-4">
          To complete your registration and join WLU, a one-time membership payment of{' '}
          <span className="font-medium text-gray-800">UGX 34,000</span> is required.
        </p>

        <p className="text-sm text-gray-500 mb-6">
          This payment helps us maintain secure, high-quality services for all members and comply
          with financial regulations. Your information is protected, and all payments are securely
          processed.
        </p>

        {!transactionRef && (
          <>
            <button
              onClick={handleInitiatePayment}
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200 disabled:opacity-50"
            >
              {loading ? 'Initiating Payment...' : 'Make Initial Payment (UGX 34,000)'}
            </button>

            <button
              onClick={logout}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200 disabled:opacity-50"
            >
              Logout
            </button>
          </>
        )}

        {transactionRef && (
          <div className="mt-6">
            <div className="mb-4">
              <p className="text-sm text-gray-700">
                Your transaction reference:{' '}
                <span className="font-mono text-gray-900">{transactionRef}</span>
              </p>
              <p className="text-sm text-gray-500 mt-1">
                Please complete the payment using your mobile device. Once done, click below to
                verify and access your account.
              </p>
            </div>

            <button
              onClick={handleVerifyPayment}
              disabled={verifying}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200 disabled:opacity-50"
            >
              {verifying ? 'Verifying Payment...' : 'Verify Payment'}
            </button>

            <button
              onClick={logout}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200 disabled:opacity-50"
            >
              Logout
            </button>
          </div>
        )}

        {statusMessage && (
          <div className="mt-4 p-3 bg-yellow-100 text-yellow-800 text-sm rounded">
            {statusMessage}
          </div>
        )}

        <div className="mt-8 text-xs text-gray-400 border-t pt-4">
          By continuing, you agree to our Terms of Service and Privacy Policy. Need help?{' '}
          <span className="text-blue-500 cursor-pointer hover:underline">Contact Support</span>.
        </div>
      </div>
    </div>
  );
};
